/**
 * Określa typy połączeń
 * 
 * czerwony - dotyczy kodu licencji
 * 
 * zielony - dotyczy wersji aplikacji
 * 
 * id                   -   identyfikator, na potrzeby react
 * originalConnection   -   określa czy połączenie jest oryginalne, tzn kod sprzętowy pasuje do kodu z licencji
 * currentVersion       -   określa czy połączenie jest z aktualnej wersji
 * filterDisplayText    -   określa tekst wyświetlany dla użytkownika w filtrze
 * redirectDisplayText  -   określa tekst wyświetlany dla użytkownika w wierszu akcji przekierowania na BO
 * cssStyle             -   określa styl css przycisku reprezetujacego dany typ
 * boldStyle            -   określa czy tekst przycisku jest pogrubiony
 * 
 */
export const ConnectionType = {
    //pasuje kod licencji oraz pasuje wesja aplikacji - zielony ciemny
    YES_LICENSE_CODE__YES_VERSION: {
        id: 1,
        originalConnection: true,
        currentVersion: true,
        //filterDisplayText: '+klucz +wersja',
        filterDisplayText: 'OK',
        redirectDisplayText: 'URUCHOM',
        cssStyle: 'w3-green',
        boldStyle: true
    },
    //pasuje kod licencji oraz nie pasuje wersja aplikacji - czerwony ciemny
    YES_LICENSE_CODE__NO_VERSION: {
        id: 2,
        originalConnection: true,
        currentVersion: false,
        //filterDisplayText: '+klucz -wersja',
        filterDisplayText: 'WERSJA',
        redirectDisplayText: 'URUCHOM',
        cssStyle: 'w3-pink',
        boldStyle: true
    },
    //nie pasuje kod licencji oraz pasuje wesja aplikacji - zielony jasny
    NO_LICENSE_CODE__YES_VERSION: {
        id: 3,
        originalConnection: false,
        currentVersion: true,
        //filterDisplayText: '-klucz +wersja',
        filterDisplayText: 'KLUCZ',
        redirectDisplayText: 'Backoffice',
        cssStyle: 'w3-pale-green',
        boldStyle: false
    },
    //nie pasuje kod licencji oraz nie pasuje wersja aplikacji - czerwony jasny
    NO_LICENSE_CODE__NO_VERSION: {
        id: 4,
        originalConnection: false,
        currentVersion: false,
        //filterDisplayText: '-klucz -wersja',
        filterDisplayText: 'KLUCZ/WERSJA',
        redirectDisplayText: 'Backoffice',
        cssStyle: 'w3-pale-red',
        boldStyle: false
    },
    //wersje DEMO
    DEMO_VERSION: {
        id: 5,
        originalConnection: null,
        currentVersion: null,
        filterDisplayText: 'DEMO',
        redirectDisplayText: null,
        cssStyle: 'w3-light-grey',
        boldStyle: null
    },
    //wszystkie - ignorujemy filtry
    ALL: {
        id: 6,
        originalConnection: null,
        currentVersion: null,
        filterDisplayText: 'WSZYSTKIE',
        redirectDisplayText: null,
        cssStyle: '',
        boldStyle: null
    }
};

/**
 * Kolekcja typów połączeń
 */
export const ConnectionTypeList = Object.keys(ConnectionType).map(type => ConnectionType[type])

/**
 * Metoda zwracająca typ połączenia bazując na dwóch parametrach wejściowych
 * 
 * @param {bool} originalConnection określa czy połączenie jest oryginalne
 * @param {bool} currentVersion określa czy połączenie ma aktualną wersję
 * 
 * @returns {ConnectionType} typ połączenia
 */
export const getConnectionType = (originalConnection, currentVersion) => {
    if (originalConnection === null && currentVersion === null)
        return ConnectionType.ALL;

    // szukamy pierwszego elementu, który spełnia warunki dla podanych parametrów wejściowych  
    let connectionType = ConnectionTypeList.find(item => item.originalConnection === originalConnection && item.currentVersion === currentVersion)
    return connectionType;
}